import React from 'react';
import { CheckCircle, CircleNotch, Info, WarningCircle, XCircle } from '@phosphor-icons/react';
import { getLanguageTexts, getSelectedLanguage } from '../language';

export function CandidateLoader({ title, description, compact = false }) {
    const t = getLanguageTexts(getSelectedLanguage());
    const loaderTitle = title || t.loading_data;
    const loaderDescription = description === undefined ? t.external_camera_loading_hint : description;

    return (
        <div className={`candidate-loading-state ${compact ? 'is-compact' : ''}`} role="status" aria-live="polite">
            <span className="candidate-loading-icon" aria-hidden="true">
                <CircleNotch size={compact ? 22 : 30} weight="bold" />
            </span>
            <span className="candidate-loading-copy">
                <strong>{loaderTitle}</strong>
                {loaderDescription && <small>{loaderDescription}</small>}
            </span>
        </div>
    );
}

export function CandidateValidationNotice({ tone = 'warning', title, children }) {
    const Icon = tone === 'success' ? CheckCircle : tone === 'info' ? Info : tone === 'danger' ? XCircle : WarningCircle;
    const alertRole = tone === 'warning' || tone === 'danger';

    return (
        <div className={`candidate-validation-notice is-${tone}`} role={alertRole ? 'alert' : 'status'}>
            <Icon size={24} weight="fill" aria-hidden="true" />
            <div>
                {title && <strong>{title}</strong>}
                {children && <span>{children}</span>}
            </div>
        </div>
    );
}
